import React from 'react';
import { useAuth } from '../components/auth/AuthProvider';
import ExportData from '../components/export/ExportData';
import { FaSignOutAlt, FaUser } from 'react-icons/fa';

const UserSettings = () => {
  const { user, signOut } = useAuth();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">User Settings</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* User Profile Section */}
        <div className="md:col-span-1">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="flex items-center mb-4">
              {user?.attributes?.picture ? (
                <img 
                  src={user.attributes.picture} 
                  alt="Profile" 
                  className="h-16 w-16 rounded-full mr-4"
                />
              ) : (
                <div className="h-16 w-16 rounded-full bg-gray-200 flex items-center justify-center mr-4">
                  <FaUser className="text-gray-500 text-2xl" />
                </div>
              )}
              <div>
                <h2 className="text-xl font-semibold">{user?.attributes?.name || 'User'}</h2>
                <p className="text-gray-600">{user?.attributes?.email || ''}</p>
              </div>
            </div>
            
            <button
              onClick={signOut}
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 w-full justify-center"
            >
              <FaSignOutAlt className="mr-2" />
              Sign Out
            </button>
          </div>
        </div>
        
        {/* Export Data Section */}
        <div className="md:col-span-2">
          <ExportData />
        </div>
      </div>
      
      {/* Additional Settings Sections */}
      <div className="mt-6">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-xl font-semibold mb-4">Backup Settings</h2>
          <p className="text-gray-600 mb-4">
            Your data is automatically backed up daily to AWS. Backups are retained for 30 days.
          </p>
          <div className="bg-blue-50 border-l-4 border-blue-500 p-4">
            <p className="text-sm text-blue-700">
              For additional data security, we recommend regularly exporting your data using the export tool above.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserSettings;
